export class Colors {
  static primary = "#28334A";
  static secondary = "#C3C5C4";

  static white = "#fff";
  static background = "#f1f1f1";

  static black = "#000";

  static error = "#f44336";
  static success = "#388e3c";
}
